import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function FoodSourceHrBlog() {
  const location = useLocation();
  const navigate = useNavigate();

  // Store state in local storage to persist it
  const [data, setData] = useState(() => {
    return (
      location.state?.blogHr || JSON.parse(localStorage.getItem("blogData"))
    );
  });

  useEffect(() => {
    if (data) {
      localStorage.setItem("blogData", JSON.stringify(data));
    }
  }, [data]);

  const handleNavigate = () => {
    navigate(-1);
  };

  const handleDeatilAffilations = (hrBlogList) => {
    navigate(`/food-source/hr/blog-list/blog-detail/${hrBlogList?.id}`, {
      state: { blog: hrBlogList, topic: data },
    });
  };

  return (
    <div className="container-fluid">
      <div className="d-flex mt-3">
        <div className="heading-main mb-3">
          <h2>{data?.name} blogs</h2>
        </div>
      </div>
      <div className="">
        <div
          className="row g-4"
          style={{ marginLeft: "10px", marginRight: "10px" }}
        >
          {[...(data?.whyItMatters || []), ...(data?.bestPractices || [])]?.map(
            (blog, index) => (
              <div
                key={index}
                className="col-6 col-sm-4 col-md-3 custom-col-5 mt-3 d-flex "
              >
                <div className="card d-flex flex-column h-100 shadow-sm">
                  <img
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDeatilAffilations(blog)}
                    src={data?.logo}
                    alt={blog?.name}
                    className="card-img-top p-0"
                  />
                  <div className="card-body flex-grow-1 d-flex flex-column card-content-partners">
                    <h5 className="card-title">{blog?.title}</h5>
                    <p className="card-text">{blog?.description}</p>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}
